var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.015 74.03C59.8304 74.03 71.03 62.8304 71.03 49.015C71.03 35.1996 59.8304 24 46.015 24C32.1996 24 21 35.1996 21 49.015C21 62.8304 32.1996 74.03 46.015 74.03Z",
    fill: "#34AADF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7235 48.4671C31.7235 48.4671 44.1147 43.1955 48.4121 41.3392C50.0596 40.5968 55.6463 38.2208 55.6463 38.2208C55.6463 38.2208 58.2248 37.1814 58.0099 39.7058C57.9383 40.7453 57.3653 44.3834 56.7923 48.3186C55.9328 53.8873 55.0017 59.9757 55.0017 59.9757C55.0017 59.9757 54.8584 61.6834 53.6408 61.9804C52.4232 62.2774 50.4176 60.941 50.0596 60.6439C49.773 60.4212 44.6877 57.08 42.8254 55.4465C42.324 55.001 41.751 54.1101 42.897 53.0706C45.4755 50.6204 48.5554 47.5762 50.4176 45.6457C51.2772 44.7547 52.1366 42.6757 48.5554 45.2002C43.47 48.8384 38.4563 52.2538 38.4563 52.2538C38.4563 52.2538 37.3103 52.9963 35.1615 52.328C33.0127 51.6599 30.5058 50.7688 30.5058 50.7688C30.5058 50.7688 28.7869 49.6551 31.7235 48.4671Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.b8555e6f5411f58676279afb83fa6c0f.svg";
export { ForwardRef as ReactComponent };